import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FitmentPicker } from "@/components/sales/draft/FitmentPicker";

// One public field's input, by its kind — picked from his lists wherever a list exists (clicking over typing).
const LIST_OF = { category: "categories", part_type: "part_types", brand: "brands", grade: "grades" };

export function DraftInput({ row, f, lists, testid }) {
  const t = row.type;
  const onBlur = () => f.status === "dirty" && f.save();
  if (t === "fixed") return <p data-testid={testid} className="h-11 flex items-center font-mono text-sm text-slate-700">{row.value || "—"}</p>;
  if (t === "bool") return (
    <button type="button" data-testid={testid} aria-pressed={!!f.val} onClick={() => f.change(!f.val, true)}
      className={`h-11 px-4 rounded-lg border-2 text-sm font-bold ${f.val ? "bg-[#1F1F1F] text-white border-[#1F1F1F]" : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50"}`}>
      {f.val ? "Yes — Call for Price" : "No — show the price"}</button>
  );
  if (LIST_OF[t]) return (
    <Select value={f.val || ""} onValueChange={(v) => f.change(v, true)}>
      <SelectTrigger data-testid={testid} className="h-11"><SelectValue placeholder="Pick from your list" /></SelectTrigger>
      <SelectContent>{(lists?.[LIST_OF[t]] || []).map((x) => <SelectItem key={x} value={x} data-testid={`${testid}-option-${x}`}>{x}</SelectItem>)}</SelectContent>
    </Select>
  );
  if (t === "flags") return (
    <div data-testid={testid} className="flex flex-wrap gap-1.5">
      {(lists?.flags || []).map((x) => {
        const on = (f.val || []).includes(x);
        return <button key={x} type="button" data-testid={`${testid}-${x}`} aria-pressed={on}
          onClick={() => f.change(on ? f.val.filter((y) => y !== x) : [...(f.val || []), x], true)}
          className={`h-11 px-3 rounded-full border text-sm font-semibold ${on ? "bg-[#1F1F1F] text-white border-[#1F1F1F]" : "bg-white text-slate-700 border-slate-300"}`}>{x}</button>;
      })}
    </div>
  );
  if (t === "fitment") return <FitmentPicker value={f.val || []} makes={lists?.makes || []} onChange={(v) => f.change(v, true)} testid={testid} />;
  if (t === "codes" || t === "words") return (
    <Input data-testid={testid} value={(f.val || []).join(", ")} onBlur={onBlur} placeholder="Separate them with commas"
      onChange={(e) => f.change(e.target.value.split(",").map((x) => x.trimStart()))} className="h-11" />
  );
  if (t === "textarea") return <Textarea data-testid={testid} value={f.val || ""} onBlur={onBlur} rows={5} onChange={(e) => f.change(e.target.value)} />;
  const numeric = ["money", "count", "year"].includes(t);
  return <Input data-testid={testid} value={f.val ?? ""} onBlur={onBlur} inputMode={numeric ? "decimal" : undefined}
    onChange={(e) => f.change(e.target.value)} className={`h-11 ${numeric || t === "code" || t === "vin" ? "font-mono" : ""}`} />;
}
